<template>
  <div v-loading="loading">
    <ContentHeader :path-info="pathInfo" :path-set-type="'replace'" />
    <div class="content-container">
      <ItemOrderPick
        @setValue="setValue"
        :orderItemList="orderForm.detailList"
        :item-type="orderForm.purchaseOrder.orderType"
        :companyEntityId="orderForm.purchaseOrder.companyEntityId"
      />
      <ItemOrderList
        :orderItemList="orderForm.detailList"
        :use-budget="budget"
        :is-urgent="orderForm.purchaseOrder.isUrgent"
        @setDesc="setDesc"
      >
        <ItemOrderAddress
          ref="address"
          @setAddress="setAddress"
          @handleExport="handleExport"
          @setAddressNum="setAddressNum"
          @setFileId="setFileId"
          :orderItemList="orderForm.detailList"
        />
        <ItemOrderRemark @setRemark="setRemark" />
      </ItemOrderList>

      <el-row class="form-item template-form-item">
        <!-- 下单方式 -->
        <!-- <el-col :span="3"><span class="required-text">*</span>下单方式</el-col>
        <el-col :span="12">
          <div class="order-type-radio">
            <el-radio-group>
              <el-radio-group v-model="orderForm.purchaseOrder.isUrgent">
                <el-radio :label="0"
                  >正常下单
                  <span class="radio-text"
                    >（即：集单模式，物料到仓后集中安排物流发运，物流运费占比10%）</span
                  >
                </el-radio>
                <el-radio :label="1"
                  >加急下单
                  <span class="radio-text">
                    （即：非集单模式，物料到仓后立即安排物流加急发运，物流运费占比13%）
                  </span>
                </el-radio>
              </el-radio-group>
            </el-radio-group>
          </div>
        </el-col>-->

        <el-col :span="3">预计到货日</el-col>
        <el-col :span="3">
          <!-- <el-date-picker
            v-model="orderForm.purchaseOrder.expectReceiveDate"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            clearable
            size="middle"
            class="time-picker"
          ></el-date-picker>-->
          <i class="el-icon-date"></i>
          {{EstimateDate | parseTime('{y}-{m}-{d}')}}
        </el-col>
        <el-col :span="6">
          <el-popover placement="right" width="250" trigger="click">
            <div class="EstimateDate">
              <div class="title">根据历史情况,为您预估时间如下:</div>
              <ul>
                <li>BPM审批预计:{{purchaseEstimate.bpmApproveDay}} 天</li>
                <li>集单:{{purchaseEstimate.setOrderDay}} 天</li>
                <li>供应商生产:{{purchaseEstimate.produceDay}} 天</li>
                <li>物流:{{purchaseEstimate.logisticsDay}} 天</li>
              </ul>
            </div>
            <span class="EstimateDate-detail" slot="reference">?</span>
          </el-popover>
        </el-col>
      </el-row>

      <div class="submit-btn">
        <el-button class="btn-red" @click="handleSubmit">+ 提交订单</el-button>
      </div>
    </div>
    <v-form ref="form" :url="exportUrl" :params="params" />
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import ItemOrderPick from './components/item-order-pick'
import ItemOrderAddress from './components/item-order-address'
import ItemOrderList from './components/item-order-list'
import ItemOrderRemark from './components/item-order-remark'
import vForm from '@/components/v-form'
import { commonUtils } from '@/utils/common'
import { mapGetters } from 'vuex'
import orderApi from '@/api/order'
export default {
  components: {
    ContentHeader,
    ItemOrderPick,
    ItemOrderAddress,
    ItemOrderList,
    ItemOrderRemark,
    vForm
  },
  data () {
    return {
      pathInfo: [],
      budget: 0,
      exportUrl: commonUtils.getApiUrl('/purchase/detail/convert-delivery'),
      params: {},
      orderForm: {
        // order-address
        deliveryList: [],
        // order-list
        detailList: [],
        purchaseOrder: {
          orderType: '',
          detailFile: '',
          // order-pick
          quotaId: '',
          trKhCode: '',
          orgCode: '',
          companyEntityId: '',
          costCenterId: '',
          // order-remark
          orderRemark: '',
          isUrgent: 0,
          // expectReceiveDate: '',
          purchaseOrg: 'CNY3',
          applyPerson: '',
          orderDesc: '',
          sdCode: ''
        }
      },
      addressNum: 1,
      loading: false,
      clientAddressId: '',
      isPrints: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      purchaseEstimate: {},
      EstimateDate: 0
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.getOrderInfo()
    this.$store.commit('setBudget', 0)
    this.orderForm.purchaseOrder.sdCode = this.userInfo.orgDTO.sdCode
  },
  methods: {
    // 获取订单信息
    getOrderInfo () {
      this.$store.dispatch('queryCartSettlement').then((res) => {
        if (res.data.resultCode === '0') {
          this.orderForm.detailList =
            res.data.resultData.quantityShoppingCart || []
          this.orderForm.detailList.forEach((item) => {
            if (!item.pocmDTO.isPrints) {
              this.isPrints = true
            }
            this.$set(item, 'printsFiles', [])
            this.$set(item, 'printsFileUri', '')
            this.$set(item, 'detailRemark', '')
            this.$set(item, 'isProof', 0)
            this.$set(item, 'subjectCategory', 'Z')
          })
          this.$store.commit('setIncrease', 1.06)
          this.setPathInfo(this.orderForm.detailList[0].pocmDTO)
          this.orderForm.purchaseOrder.companyEntityId =
            this.orderForm.detailList[0].companyEntityId
          this.queryPurchaseEstimate()
        }
      })
    },

    // 添加pathInfo
    setPathInfo (itemInfo) {
      this.pathInfo = [{ path: '/material/index', name: 'POCM订购' }]
      if (itemInfo.isPrints) {
        this.orderForm.purchaseOrder.orderType = '02'
        this.pathInfo.push({ path: '/material/printing-list', name: '印刷品' })
      } else if (!itemInfo.isPrints && itemInfo.isStandard) {
        this.orderForm.purchaseOrder.orderType = '01'
        this.pathInfo.push({
          path: '/material/menu-list',
          name: 'Menu清单'
        })
      } else {
        this.orderForm.purchaseOrder.orderType = '03'
        this.pathInfo.push({
          path: '/material/non-menu-more',
          name: 'Non-Menu'
        })
      }
      if (this.$route.query.type === 'cart') {
        this.pathInfo.push({ path: '/cart', name: '购物车' })
      }
    },

    // 获取订单描述
    setDesc (val) {
      this.orderForm.purchaseOrder.orderDesc = val
    },

    // 获取预算和报账实体
    setValue (val) {
      this.orderForm.purchaseOrder.quotaId = val.quotaId
      this.orderForm.purchaseOrder.trKhCode = val.trKhCode
      this.orderForm.purchaseOrder.orgCode = val.orgCode
      this.orderForm.purchaseOrder.costCenterId = val.costCenterId
      // this.orderForm.purchaseOrder.purchaseOrg = val.purchaseOrg
      this.budget = val.budget
    },

    // 通过订单明细生成excel
    handleExport () {
      this.$refs.form.submit()
    },

    // 获取地址
    setAddress (value) {
      this.orderForm.deliveryList = value.deliveryAddress
      this.clientAddressId = value.clientAddressId
      this.orderForm.purchaseOrder.applyPerson = value.applyPerson
    },
    // 获取备注
    setRemark (val) {
      this.orderForm.purchaseOrder.orderRemark = val
    },

    // 获取fileid
    setFileId (id) {
      this.orderForm.purchaseOrder.detailFile = id
    },

    // 获取地址数量
    setAddressNum (val) {
      this.addressNum = val
    },

    // 获取预计收货时间
    queryPurchaseEstimate () {
      let itemIdList = ''
      this.orderForm.detailList.forEach(item => {
        itemIdList += item.pocmDTO.itemId + ','
      })
      orderApi.queryPurchaseEstimate({ itemIdList: itemIdList }).then(res => {
        if (res.data.resultCode === '0') {
          this.purchaseEstimate = res.data.resultData.estimateDate
          for (let i in this.purchaseEstimate) {
            this.EstimateDate += this.purchaseEstimate[i]
          }
          let currentDate = Date.parse(new Date())
          this.EstimateDate = currentDate + this.EstimateDate * (86400 * 1000)
          this.orderForm.purchaseOrder.expectReceiveDate = this.EstimateDate
        }
      })
    },
    // 订单验证
    checkSubmit () {
      if (
        !this.orderForm.purchaseOrder.quotaId &&
        !this.orderForm.purchaseOrder.trKhCode
      ) {
        this.$message.error('请选择预算')
        return false
      }
      if (!this.orderForm.purchaseOrder.costCenterId) {
        this.$message.error('请输入成本中心Code并验证')
        return false
      }
      // if (!this.orderForm.purchaseOrder.purchaseOrg) {
      //   this.$message.error('请选择采购组织')
      //   return false
      // }
      if (!this.orderForm.purchaseOrder.orderDesc) {
        this.$message.error('请输入订单描述')
        return false
      }
      if (this.addressNum && !this.$refs.address.checkAddressMaterial()) {
        return false
      }
      if (this.addressNum && !this.orderForm.purchaseOrder.applyPerson) {
        this.$message.error('请输入申请人姓名')
        return false
      }
      if (this.addressNum && !this.orderForm.deliveryList.length) {
        this.$message.error('请检查收货地址')
        return false
      }
      if (!this.addressNum && !this.orderForm.deliveryList.length) {
        this.$message.error('请上传物流发货明细文档')
        return false
      }
      // if (!this.orderForm.purchaseOrder.expectReceiveDate) {
      //   this.$message.error('请选择期望收货日期')
      //   return false
      // }
      return true
    },

    // 验证code
    checkCode () {
      let detailCode = []
      let deliveryCode = []
      this.orderForm.detailList.forEach((item) => {
        detailCode.push(item.pocmDTO.itemCode)
      })
      this.orderForm.deliveryList.forEach((item) => {
        deliveryCode.push(item.itemCode)
      })
      detailCode = commonUtils.unique(detailCode)
      deliveryCode = commonUtils.unique(deliveryCode)
      if (
        JSON.stringify(detailCode.sort()) !==
        JSON.stringify(deliveryCode.sort())
      ) {
        this.$message.error('物流发货明细文档物料编码填写错误')
        return false
      }
      return true
    },

    // 验证数量
    checkQuantity () {
      let detailAmount = null
      let deliveryAmount = null
      this.orderForm.detailList.forEach((item) => {
        detailAmount += item.itemQuantity
      })
      this.orderForm.deliveryList.forEach((item) => {
        deliveryAmount += item.purchaseQuantity
      })
      if (detailAmount !== deliveryAmount) {
        this.$message.error('物流发货明细文档物料数量错误')
        return false
      }
      return true
    },

    // 提交订单
    handleSubmit () {
      if (!this.checkSubmit()) {
        return
      }
      this.orderForm.detailList.forEach((item) => {
        this.$set(item, 'purchaseQuantity', item.itemQuantity)
        if (typeof item.subjectCategory === 'boolean') {
          item.subjectCategory = ''
        }
      })
      if (this.addressNum) {
        this.orderForm.purchaseOrder.detailFile = ''
        // this.orderForm.deliveryList = []
        // this.orderForm.deliveryList.push({
        //   clientAddressId: this.clientAddressId
        // })
      }
      if (!this.addressNum) {
        if (!this.checkQuantity()) {
          return
        } else if (!this.checkCode()) {
          return
        }
      }
      this.orderForm.detailList.forEach((item) => {
        if (typeof item.printsFiles === 'object') {
          item.printsFiles = item.printsFiles.join(',')
        }
      })
      this.loading = true
      this.$store
        .dispatch('createOrder', this.orderForm)
        .then((res) => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$router.replace({
              path: '/material/item-order-success',
              query: { orderNumber: res.data.resultData.orderNumber }
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('提交失败')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-btn {
  text-align: center;
  margin-top: $content-large;
}
.form-item {
  padding: $content-large;
}
.radio-text {
  font-weight: normal;
}
.time-picker {
  margin-top: -10px;
}
.EstimateDate-detail {
  display: inline-block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  border: 3px solid #c8102d;
  border-radius: 50%;
  text-align: center;
  line-height: 15px;
  color: #c8102d;
  font-weight: 700;
  position: relative;
  top: -5px;
  cursor: pointer;
}
.EstimateDate {
  padding: 12px;
  .title {
    font-weight: 700;
    font-size: 15px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #ccc;
  }
  ul {
    margin-bottom: 0;
    padding-left: 20px;
  }
}
</style>
